import type { Theme } from '@mui/material/styles';
import { headerStripSurface } from '../../../theme/gridSurfaces';

/**
 * Surfaces for the "All Patient Notes (Aggregated View)" grid.
 *
 * GP-1232: zebra striping used `grey.50`, row hover `grey.100` and the header
 * strip `grey.200`. The dark palette reuses the LIGHT grey ramp (see
 * `theme/index.ts` — `grey.50` is `#F8F9FA` in both modes), so in dark mode
 * every even row painted as a near-white bar underneath the light dark-mode
 * text: the Date/Time, Preview, Source and Author cells were invisible.
 *
 * The `action.*` overlays are translucent and mode-aware, so they tint
 * whatever surface the grid sits on instead of replacing it with a fixed hue.
 *
 * Rule order matters: `:nth-of-type(even)` and `:hover` have equal
 * specificity, so the stripe has to come FIRST — otherwise it wins on source
 * order and even rows never show a hover state.
 *
 * Lives outside `ComprehensiveNotesPanel.tsx` so its spec can import it
 * without pulling in `@mui/x-data-grid` (whose bundled CSS vitest can't
 * resolve).
 */
export const notesGridSx = (theme: Theme) => ({
  height: '100%',
  '& .MuiDataGrid-row': {
    cursor: 'pointer',
    '&:nth-of-type(even)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
    },
  },
  '& .MuiDataGrid-cell': {
    fontFamily: 'Roboto, sans-serif',
  },
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: headerStripSurface(theme),
    fontWeight: 600,
  },
});
